import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentUserAccount, StateStatus } from '@guryou/redux';

import { resetState } from '../actions';
import { CURRENT_USER, UPDATE_USER } from '../new';

import { useEffectOnSuccess } from '.';

const useCurrentUser = () => {
  const dispatch = useDispatch();
  const { data, status, version, entity } = useSelector(state => state.user.current);

  useEffect(() => {
    if (status === StateStatus.NOT_INITIALIZED) {
      dispatch(getCurrentUserAccount());
    }
  }, [dispatch, status]);

  useEffectOnSuccess(
    state => state.user.update,
    () => {
      dispatch(resetState(CURRENT_USER));
      dispatch(resetState(UPDATE_USER));
    }
  );

  return { user: data, status, version, entity };
};

export default useCurrentUser;
